module.exports = __webpack_public_path__ + "img/purple_kakaotalk.973d2ee4.svg";